import { object, string, array, lazy } from 'yup';

function validateEmptyLines(message) {
  return (value) =>
    value.length === 1
      ? array().of(
          object().shape({
            content: array().required(message),
          }),
        )
      : array().of(
          object().shape({
            content: array(),
          }),
        );
}

const scoringRubricSchema = array()
  .min(1, 'Rubric should contain at least one category.')
  .of(
    object().shape({
      sectionTitle: string().required(
        'This field is required. Please enter scoring section title.',
      ),
      scoringInstructions: object().shape({
        content: lazy(
          validateEmptyLines(
            'This field is required. Please enter scoring instructions.',
          ),
        ),
      }),
      scoringFeedback: array()
        .min(2, 'Every rubric item must have at least 0 and 1 points')
        .of(
          object().shape({
            feedback: object().shape({
              content: lazy(
                validateEmptyLines(
                  'This field is required. Please enter the score feedback.',
                ),
              ),
            }),
            criterias: array()
              .of(
                object().shape({
                  description: object()
                    .shape({
                      content: lazy(
                        validateEmptyLines('Criteria must have content.'),
                      ),
                    })
                    .nullable(),
                }),
              )
              .nullable(),
          }),
        ),
    }),
  );

export default scoringRubricSchema;
